export enum Boroughs {
    Bronx = 'BRONX',
    Brooklyn = 'BROOKLYN',
    Manhattan = 'MANHATTAN',
    Queens = 'QUEENS',
    StatenIsland = 'STATEN ISLAND',
}